import { green, grey, orange, red } from '@material-ui/core/colors';
import { ColorPalette } from '../../themes/soho/ColorPalette';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';
import Error from '@material-ui/icons/Error';
import PendingIcon from '@material-ui/icons/PauseCircleOutline';
import InProgressIcon from '@material-ui/icons/TimelapseOutlined';
import Warning from '@material-ui/icons/Warning';
import NotStartedIcon from '@material-ui/icons/AdjustOutlined';

export enum ActionState {
    NotStarted = 'NotStarted',
    Pending = 'Pending',
    InProgress = 'InProgress',
    Passed = 'Passed',
    Failed = 'Failed',
    Unknown = 'Unknown'
}

export enum ExecutionStatus {
    InProgress = 'InProgress',
    AwaitingApprovals = 'AwaitingApprovals',
    Scheduled = 'Scheduled',
    Ready = 'Ready',
    Failed = 'Failed',
    PassedWithWarnings = 'PassedWithWarnings',
    Passed = 'Passed',
    Cancelled = 'Cancelled',
}

export enum TestStatus {
    Passed = 'Passed',
    Failed = 'Failed',
    Errored = 'Errored',
    TimedOut = 'TimedOut'
}

const executonConstants = {
    ActionStateLabels: {
        NotStarted: 'Not Started',
        Pending: 'Pending',
        InProgress: 'In Progress',
        Passed: 'Complete',
        Failed: 'Failed',
        Unknown: 'Unknown'
    },
    ActionStateColors: {
        Pending: orange[500],
        InProgress: ColorPalette.$azure05,
        Passed: green[500],
        Failed: red[500],
        Unknown: grey[600]
    },
    TestStatusColors: {
        Passed: green[500],
        Failed: red[500],
        Errored: red[500],
        TimedOut: grey[600]
    },
    ActionStateIcons: {
        NotStarted: NotStartedIcon,
        Passed: CheckCircleIcon,
        Failed: Error,
        InProgress: InProgressIcon,
        Pending: PendingIcon,
        Unknown: Warning
    },
    ExecutionPlanLabels: {
        'TEARDOWN_ALL': 'Teardown',
        'DEPLOY_WITH_TEARDOWN': 'Deploy, Test, & Teardown',
        'DEPLOY_TEARDOWN': 'Deploy, Test, & Teardown',
        'DEPLOY_WITHOUT_TEARDOWN': 'Deploy & Test',
        'DEPLOY': 'Deploy & Test'
    },
    ExecutionStatusLabels: {
        InProgress: 'In Progress',
        AwaitingApprovals: 'Awaiting Approvals',
        Scheduled: 'Scheduled',
        Ready: 'Ready',
        Failed: 'Failed',
        PassedWithWarnings: 'Passed With Warnings',
        Passed: 'Complete',
        Cancelled: 'Cancelled'
    }
};

export default executonConstants;
